const ITEMS = [
  "14.5M women-owned US businesses",
  "$3.3T annual revenue",
  "1× circulation · leaks by design",
  "Ownership not required on packaging",
  "No shelf-level infrastructure",
  "NA · LATAM · EU · East Africa",
  "Target: 6–8× velocity",
  "$19–26T realized economic activity",
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="ticker"
      className="bg-white text-ink border border-line border-b border-line overflow-hidden"
    >
      <div className="relative flex items-center h-14">
        <div className="flex whitespace-nowrap animate-ticker will-change-transform">
          {doubled.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-6 pr-10"
              aria-hidden={idx >= ITEMS.length ? "true" : undefined}
            >
              <span className="font-sans font-semibold text-[12px] uppercase tracking-[0.28em] text-brand-orange tabular-nums">
                {item}
              </span>
              <span className="w-1.5 h-1.5 bg-brand-orange rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
